import { ActionIcon, Flex } from "@mantine/core";
import { IconPlus, IconTrash } from "@tabler/icons-react";
import { useWatch } from "react-hook-form";
import useInputListController from "src/generator/hooks/useInputListController";
import { StyledActionIcon } from "src/styled";

import MedHistoryButton from "../MedHistory/MedHistoryButton";
import BATItem from "./BATItem";

interface IBATITem {
  type: string;
  text: string;
  filename: string;
  filetype: string;
  b64: string;
}

interface Props {
  id: string;
  value: any;
  required: boolean;
  history?: boolean;
  dynamicRows?: boolean;
  list?: IBATITem[];
  label?: string;
  tag: string;
}

const BoolAttachText = ({
  id,
  list,
  history,
  dynamicRows,
  label,
  tag,
}: Props) => {
  const formListValue = useWatch({
    name: id,
  });

  const actualList =
    formListValue && Array.isArray(formListValue) ? formListValue : list || [];

  const { fields, handleAdd, handleRemove } = useInputListController({
    list: actualList,
    id,
  });

  return (
    <Flex justify="space-between" gap="sm" style={{ width: "100%" }}>
      <Flex direction="column" gap="sm" style={{ flex: 1 }}>
        {fields.map((item, index) => (
          <Flex key={item.id} align="center" gap="sm">
            <BATItem
              {...(item as unknown as IBATITem)}
              id={`${id}.${index}`}
              label={label ?? ""}
            />
            <ActionIcon color="red" onClick={handleRemove(index)}>
              <IconTrash />
            </ActionIcon>
          </Flex>
        ))}
      </Flex>
      <Flex align="flex-end" gap="sm">
        {history && <MedHistoryButton tag={tag} />}
        {dynamicRows && (
          <StyledActionIcon onClick={handleAdd}>
            <IconPlus />
          </StyledActionIcon>
        )}
      </Flex>
    </Flex>
  );
};

export default BoolAttachText;
